import React from 'react';
import { Button } from 'wbm-inputs';

type filterProps = {
    button: string,
    filterChips: Element,
    onClick: any,
}

export const ModalSlideoutFooterFilter = ({ ...props }: filterProps) => {
    return (
        <div className="modal-slider-footer-filter">
            {props.filterChips ? <div className="filter-chips">
                {props.filterChips}
            </div> : null}
            <div className="button-container">
                <Button className="btn-primary" onClick={props.onClick}>{props.button}</Button>
            </div>
        </div>
    );
}